module.exports = __webpack_public_path__ + "static/media/pagetypes.46adc838.jpg";